<template>
  <div class="meau">
    <el-container>
      <el-header>
        <div class="header">
          <div
            ref="scorll_top"
            class="logo"
          >
            <img
              src="@/assets/logo/lclogo.png"
              alt=""
            >
          </div>
          <div class="list">
            <el-menu
              :default-active="activeIndex"
              mode="horizontal"
              text-color="#333333"
              active-text-color="#2D71F6"
              @select="handleSelect"
            >
              <el-menu-item
                v-for="(meau, meauIndex) in meauList"
                :key="meauIndex"
                :index="meau.id.toString()"
              >
                <div @click="routeList(meau)">
                  <div
                    v-if="activeIndex == meau.id && isShow"
                    class="menu_lists"
                  >
                    {{ meau.name }}
                    <div
                      class="aaaaaa"
                      @mouseleave="mouseleave"
                    >
                      <div class="vvvv">
                        <div
                          v-for="(child, childIndex) in childList"
                          :key="childIndex"
                          class="child_ists"
                        >
                          <div class="child_list">
                            {{ child.name }}
                            <div
                              v-for="(c, cIndex) in child.contents"
                              :key="cIndex"
                              :class="$route.fullPath == c.url
                                ? 'active_list'
                                : 'contents_list'
                              "
                            >
                              <div @click="routeUrl(c)">
                                {{ c.name }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-else>
                    {{ meau.name }}
                  </div>
                </div>
              </el-menu-item>
            </el-menu>
          </div>
        </div>
      </el-header>
      <el-main>
        <router-view v-if="isLoad" />
      </el-main>
      <el-footer>
        <BottomFoo
          style="height: auto"
          @routerPage="routerPage"
        />
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import BottomFoo from '@/views/menu/components/bottom.vue'
export default {
  // 组件名称
  name: 'Home',
  // 局部注册的组件
  components: {
    BottomFoo
  },
  // 组件参数 接收来自父组件的数据
  props: {},
  // 组件状态值
  data() {
    return {
      // 是否刷新
      isLoad: true,
      // 当前所在页
      activeIndex: '1',
      // 菜单列表
      meauList: [
        {
          id: 1,
          name: '首页',
          url: '/home',
          child: []
        },
        {
          id: 2,
          name: '安全产品',
          url: '/home',
          anchor: '#anchor6',
          child: [
            {
              id: 21,
              name: ' ',
              contents: [
                {
                  name: '网络安全应急工具箱系统',
                  url: '/emergencyToolbox'
                },
                {
                  name: '网络协议端口识别系统',
                  // url: '/port'
                  url: '/expect'
                },
                {
                  name: '互联网漏洞扫描分析系统',
                  // url: '/verb'
                  url: '/expect1'
                },
                {
                  name: '网络安全资产运行维护管理系统',
                  // url: '/maintain'
                  url: '/expect2'
                },
                {
                  name: '网络空间资产风险感知系统',
                  url: '/camasPro'
                },
                {
                  name: '网络安全及信息化能力提升系统',
                  url: '/informationization'
                  // url: '/expect3'
                },
                {
                  name: '信息化及安全服务量化系统',
                  // url: '/safe'
                  url: '/expect4'
                },
                {
                  name: '自动化流程编排系统',
                  // url: '/auto'
                  url: '/expect5'
                }

              ]

            }
          ]
        },
        {
          id: 3,
          name: '安全服务',
          url: '',
          anchor: '#anchor6',
          child: [
            {
              id: 31,
              name: '安全评估',
              contents: [
                {
                  name: '风险评估',
                  url: '/risk'
                },
                {
                  name: '渗透测试',
                  url: '/seep'
                },

                {
                  name: '安全检查',
                  url: '/inspect'
                },
                {
                  name: '代码审计',
                  url: '/audit'
                }
              ]
            },
            {
              id: 32,
              name: '咨询规划及培训',
              contents: [
                {
                  name: '安全意识培训',
                  url: '/realize'
                },
                {
                  name: '行业安全咨询',
                  url: '/sector'
                },
                {
                  name: '安全体系规划设计',
                  url: '/planning'
                },
                {
                  name: '安全技术培训',
                  url: '/training'
                }
              ]
            },
            {
              id: 33,
              name: '重保应急',
              contents: [
                {
                  name: '安全监测',
                  url: '/monitor'
                },
                {
                  name: '安全巡检',
                  url: '/inspection'
                },
                {
                  name: '安全通告',
                  url: '/notify'
                },
                {
                  name: '重保值守',
                  url: '/guardAgain'
                },
                {
                  name: '应急响应',
                  url: '/emergency'
                }
              ]
            },
            {
              id: 34,
              name: '安全运营',
              contents: [
                {
                  name: '安全运营',
                  url: '/safeOperation'
                }
              ]
            },
            {
              id: 35,
              imgUrl: require('@/assets/home/services5.png'),
              name: '攻防演练',
              contents: [
                {
                  id: 51,
                  name: '攻防演练',
                  url: '/attackDrill'
                }
              ]
            }
          ]
        },
        {
          id: 4,
          name: '解决方案',
          url: '',
          anchor: '#anchor2',
          child: [
            {
              id: 41,
              name: '行业应用场景',
              contents: [
                {
                  name: '医疗',
                  url: '/medicalCare'
                },
                {
                  name: '关键基础设施',
                  url: '/infrastructure'
                },
                {
                  name: '企业',
                  url: '/enterprise'
                },
                {
                  name: '政府',
                  url: '/government'
                }
              ]
            },
            {
              id: 42,
              name: '技术解决问题',
              contents: [
                {
                  name: '等级保护建设方案',
                  url: '/gradeProtection'
                },
                {
                  name: '数据安全解决方案',
                  url: '/dataSecurity'
                },
                {
                  name: '系统安全加固方案',
                  url: '/systemSecurityReinforcement'
                },
                {
                  name: '主机安全加固方案',
                  url: '/hostSecurityReinforcement'
                },
                {
                  name: '终端一体化解决方案',
                  url: '/terminalIntegration'
                },
                {
                  name: '安全运营解决方案简约版',
                  url: '/simpleVersionOfSafeOperation'
                },
                {
                  name: '跨网交换解决方案',
                  url: '/crossNetworkSwitching'
                },
                {
                  name: '全流量安全监测分析服务解决方案',
                  url: '/fullFlowSafety'
                }
              ]
            }
          ]
        },
        {
          id: 6,
          name: '应用案例',
          url: ''

        },
        {
          id: 7,
          name: '技术支持',
          url: '',
          child: [
            {
              id: 71,
              name: '',
              contents: [
                {
                  name: '技术支持',
                  url: '/sup'
                }

              ]
            }
          ]
        },
        {
          id: 5,
          name: '关于我们',
          url: '',
          child: [
            {
              id: 51,
              name: '关于我们',
              contents: [
                {
                  name: '灵创简介',
                  url: '/synopsis'
                },
                {
                  name: '新闻动态',
                  url: '/news'
                },
                // { name: '英才招聘', url: '/recruit' },
                {
                  name: '联系我们',
                  url: '/contact'
                }
              ]
            }
          ]
        }
      ],
      isShow: false,
      childList: []
    }
  },
  watch: {
    $route(to, from) {
      this.activeIndex = sessionStorage.getItem('activeIndex')
    }
  },
  mounted() { },
  activated() {
    this.activeIndex = sessionStorage.getItem('activeIndex')
    if (this.activeIndex == null) {
      this.activeIndex = '1'
    }
  },
  // 组件方法
  methods: {
    handleSelect(key, keyPath) {
      this.activeIndex = key
      if (this.activeIndex === 1) {
        sessionStorage.setItem('activeIndex', '1')
      }
    },
    mouseleave() {
      this.isShow = false
    },
    routeList(item) {
      // console.log(item)
      this.isShow = true
      this.childList = item.child
      if (item.id === 3) {
        sessionStorage.setItem('activeIndex', '3')
      } else if (item.id === 5) {
        sessionStorage.setItem('activeIndex', '5')
      } else if (item.id === 4) {
        sessionStorage.setItem('activeIndex', '4')
      } else if (item.id === 2) {
        sessionStorage.setItem('activeIndex', '2')
      } else if (item.id === 7) {
        sessionStorage.setItem('activeIndex', '7')
      }
      if (item.id === 1) {
        this.$router.push(item.url)
      }
    },
    routeUrl(item) {
      this.$router.push(item.url)
    },
    // 路由跳转
    routerPage(anchor) {
      this.isLoad = false
      if (anchor) {
        this.$router.push({
          path: '/home',
          query: {
            anchor: anchor
          }
        })
        setTimeout(() => {
          this.isLoad = true
        }, 10)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.meau {
  width: 100%;
  height: auto;
  color: #000;
}

.el-main {
  padding: 0px;
  overflow: hidden;
}

.el-footer {
  padding: 0;
}

.el-header {
  padding: 0;
  width: 100%;
  height: 104px;

  .header {
    width: 80%;
    min-width: 1000px;
    padding: 0 10%;
    position: fixed;
    top: 0;
    z-index: 10;
    background: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;

    img {
      width: 158px;
      height: 54px;
      display: flex;
      align-items: center;
    }

    .list {
      ::v-deep .el-menu--horizontal>.el-menu-item {
        font-size: 18px;
      }

      .el-menu--horizontal>.el-menu-item.is-active {
        border-bottom: 3px solid #409eff;
      }

      .el-menu.el-menu--horizontal {
        border-bottom: none;
      }
    }
  }
}

@media (max-width: 1250px) {
  .el-header {
    width: 100%;

    .header {
      width: 90% !important;
      padding: 0 5% !important;
    }
  }
}

.menu_lists {
  position: relative;

  .aaaaaa {
    position: absolute;
    left: 0;
    right: 0;
    top: 60px;
    width: 100%;

    .vvvv {
      width: 100%;
      display: flex;
      justify-content: space-around;

      .child_ists {
        background: #fff;
        padding: 5px 19px;
        line-height: 40px;

        .child_list {
          font-size: 16px;
          color: #333333;
          font-weight: bold;

          .contents_list {
            font-weight: 400;
            font-size: 14px;
            color: #666666;
            cursor: pointer;
          }

          .active_list {
            font-weight: bold;
            font-size: 14px;
            color: #2d71f6;
            cursor: pointer;
          }
        }
      }
    }
  }
}
</style>
